export const CraftyControlActions = {
    connecting: 'CRAFTY/CONNECTING',
    disconnected: 'CRAFTY/DISCONNECTED',
    connected: 'CRAFTY/CONNECTED',
    setCurrentTemperature: 'CRAFTY/SET_CURRENT_TEMPERATURE',
    setSetPoint: 'CRAFTY/SET_SETPOINT',
    setBoost: 'CRAFTY/SET_BOOST',
    setLED: 'CRAFTY/SET_LED',
    updateSetPoint: 'CRAFTY/UPDATE_SETPOINT',
    updateBoost: 'CRAFTY/UPDATE_BOOST',
    updateLED: 'CRAFTY/UDPATE_LED',
    setBatteryPercent: 'CRAFTY/SET_BATTERY_PERCENT',
    updateUnits: 'CRAFTY/UPDATE_UNITS',
    updateSettings: 'CRAFTY/UPDATE_SETTINGS',
    updating: 'CRAFTY/UPDATING',
    updated: 'CRAFTY/UPDATED',
    setSerial: 'CRAFTY/SET_SERIAL',
    setModel: 'CRAFTY/SET_MODEL',
    setVersion: 'CRAFTY/SET_VERSION',
    setHoursOfOperation: 'CRAFTY/SET_HOURS_OF_OP',
    setPointStepChanged: 'CRAFTY/SETPOINT_STEP',
    boostStepChanged: 'CRAFTY/BOOST_STEP',
    setData: 'CRAFTY/SET_DATA',
    setPowerState: 'CRAFTY/SET_POWER_STATE',
};